export default __webpack_public_path__ + "static/media/small_Frame.d0dd7151.svg";